import * as React from 'react';
import { isStaleOrgScenario } from '../services/atlasProjectionContext';

/** A failed projection must not obscure the controls needed to recover it. */
export const OrgProjectionErrorNotice: React.FC<{
  error: unknown;
  onRetry: () => void;
  onOpenWorkbench?: () => void;
  isShowingLiveContext?: boolean;
}> = ({ error, onRetry, onOpenWorkbench, isShowingLiveContext = false }) => {
  const stale = isStaleOrgScenario(error);
  return (
    <div role="alert" className="absolute bottom-24 left-1/2 z-50 w-80 max-w-[calc(100%-2rem)] -translate-x-1/2 rounded-lg border bg-background p-4 text-sm shadow-lg">
      <p>{stale
        ? `${isShowingLiveContext ? 'Showing the current organization, not the plan preview. ' : ''}The organization changed. Open Review changes and rebase this plan to restore its preview.`
        : 'Organization data could not be loaded. Try again.'}</p>
      {stale ? onOpenWorkbench && (
        <button type="button" className="mt-2 min-h-10 underline" onClick={onOpenWorkbench}>Open staffing workbench</button>
      ) : (
        <button type="button" className="mt-2 min-h-10 underline" onClick={onRetry}>Retry</button>
      )}
    </div>
  );
};
